import React, { useContext, useEffect } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useQuery } from "react-query";
import User from "../../components/user/User";
import { Box, Text, VStack, Button } from "@chakra-ui/react";
import { getUsers } from "../../services/user";
import { UserSkeleton } from "../../components/user/User";
import { AdminContext } from "../../contexts/AdminContext";

export default function Users() {
  const { admin } = useContext(AdminContext)

  const token = `bearer ${admin.token}`
  const users = useQuery('users', () => getUsers(token))

  useEffect(() => {
    document.title = "Users";
  }, []);

  return (
    <React.Fragment>
      <DashboardLayout>
        <Box>
          <Text
            fontWeight='semibold' fontSize='lg'
            mt='10' color='gray.500'>
            Users
          </Text>

          <VStack
            py='8'px='5' boxShadow='md' borderRadius='8' w='100%' mt='5' spacing='4' maxH='39rem' overflowY='auto'
          >  
          {users.data &&
            users.data.map((user: any) => (
              <User key={user._id} user={user} />
            ))
          }

          {users.isLoading &&
            [1, 2, 3, 4, 5, 6, 7,].map((num: any) => (
              <UserSkeleton key={num} />
            ))
          }

          {users.isError &&
            <Box textAlign='center'>
              <Text
                p='2' color='red.500'
                fontWeight='semibold'
              >
                Failed to fetch Users
              </Text>

              <Button colorScheme='green' size='lg' onClick={() => users.refetch()}>
                Try again
              </Button>
            </Box>
          }
          </VStack>  
        </Box>
      </DashboardLayout>
    </React.Fragment>
  )
}